import {
    LOGIN_USER,
    LOGOUT_USER,
    SET_CARD_TOKEN,
    LOGIN_AS_CUSTOMER,
    UPDATE_CUSTOMER
} from '../actions/actions';
import { writeSharedSession, clearSharedSession } from '../helpers/crossUiSession';

const initialState = {
    customer: null,
    user: null
};

const user = (state = initialState, action) => {
    if (action.type === LOGIN_USER) {
        localStorage.setItem('userToken', action.user.token);
        // Mirror into the shared blob so the new frontend can adopt this
        // session when the user toggles UIs (see helpers/crossUiSession).
        writeSharedSession(action.user.token, action.user);
        // do not auto login agent as the guest
        if (action.user.role === 'agent') {
            return { ...state, customer: null, user: action.user };
        }
        return { ...state, customer: action.user, user: action.user };
    }
    if (action.type === LOGIN_AS_CUSTOMER) {
        return { ...state, customer: action.user };
    }
    if (action.type === LOGOUT_USER) {
        localStorage.removeItem('userToken');
        clearSharedSession();
        const filters = localStorage.getItem('filters');
        if (filters && filters.search('showastable') !== -1) {
            const params = new URLSearchParams(filters);
            params.delete('showastable');
            localStorage.setItem('filters', params);
        }
        return { ...initialState };
    }
    if (action.type === SET_CARD_TOKEN) {
        return { ...state, customer: { ...state.customer, ...action.cardToken } };
    }

    if (action.type === UPDATE_CUSTOMER) {
        return {
            ...state,
            customer: action.customer
        };
    }

    return state;
};

export default user;
